import React, { useRef } from 'react';
import { ActionButton } from '@manulife/mux';
import { Plus } from '@manulife/mux-cds-icons';
import { useTranslation } from './translationContext';

const TableFilterAddButton = ({
  setSearchAppliedIcon,
  visibleSearchFields,
  disabledFlag,
  setVisibleSearchFields,
  filterOptions
}) => {
  const addRef = useRef<HTMLButtonElement>();
  const { t } = useTranslation();

  const firstRemainingField = filterOptions.filter(filter => !visibleSearchFields.includes(filter))[0];

  function onClick() {
    setVisibleSearchFields([...visibleSearchFields, firstRemainingField]);
    setSearchAppliedIcon(false);
  }

  return (
    <ActionButton
      id={'add-search-button'}
      className="add-search"
      aria-label={t('tablefilter.addFields')}
      icon={<Plus />}
      ref={addRef}
      disabled={disabledFlag}
      onClick={onClick}>
      {t('tablefilter.addFields')}
    </ActionButton>
  );
};

export default TableFilterAddButton;
